import React from "react";
import { LoginForm } from "../auth/LoginForm";

export default function LoginPage() {
  // Поскольку LoginForm теперь сам управляет своим фоном и центрированием,
  // дополнительная обертка здесь больше не нужна.
  return <LoginForm />;
}
